import { withStyles } from '@material-ui/core';

import RepeatTick from './component';
import styles from './styles';

export default withStyles(styles)(RepeatTick);
